const routes = [
    {
        path: '/virtual/internships/program',
        component: () => import('../pages/Index'),
        meta: {
            isAuthenticated: true,
            isStaff: true,
            permission: 'virtualinternshipprogram_index'
        }
    }
];

export default routes;
